import script from "./WriterMapComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WriterMapComponent.vue?vue&type=script&setup=true&lang=js"

import "./WriterMapComponent.vue?vue&type=style&index=0&id=e9bc65b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9bc65b2"]])

export default __exports__